import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

import MainPageComponent from '../_generic/main.page.component';

const styles = () => ({
  loadingWrapper: {
    paddingTop: '5%',
    textAlign: 'center',
  },
  progress: {
    margin: '0 auto',
  },
});

const LoadingComponent = ({ classes }) => (
  <MainPageComponent>
    <div className={classes.loadingWrapper}>
      <CircularProgress className={classes.progress} size={100} color="secondary" disableShrink={true}/>
    </div>
  </MainPageComponent>
);

LoadingComponent.propTypes = {
  /* eslint-disable react/forbid-prop-types */
  classes: PropTypes.object.isRequired,
  /* eslint-enable */
};

export default withStyles(styles)(LoadingComponent);
